import { useSyncExternalStore } from 'react';
import { getRunnerUiSnapshot, subscribeRunnerUi } from '../../state/runnerUiStore.ts';
import { RUNNER_DOM } from './runnerDomIds.ts';
import { useI18n } from 'shared/lib/i18n.tsx';

export function RunnerPause() {
  const d = RUNNER_DOM;
  const { t } = useI18n();
  const s = useSyncExternalStore(subscribeRunnerUi, getRunnerUiSnapshot, getRunnerUiSnapshot);

  return (
    <div
      id={d.pauseRoot}
      className="runner-pause"
      hidden={!s.pauseVisible}
      role="dialog"
      aria-modal="true"
      aria-labelledby={d.pauseTitle}
    >
      <div className="runner-pause__panel">
        <h2 id={d.pauseTitle} className="runner-pause__title">{t('game.pause')}</h2>
        <div className="runner-pause__score">{s.score}</div>
      </div>
    </div>
  );
}
